import { Attachment } from 'src/app/model/attachment';

export class FormState {
  id: string
  attachment: Attachment;
  descrizione: string;
  roles: string[];
}
